import { notification } from "antd";
import { useEffect } from "react";

import { AssetErrorEventDataFragment } from "../../graphql/graphql";
import { formatAssetErrorId } from "../../utils/assetErrorHelpers";
import NavigateButton from "../NavigateButton";

interface AssetErrorPopupProps {
  assetErrorEvent: AssetErrorEventDataFragment;
  handleOnClose: () => void;
}

const getErrorMessage = (
  assetErrorEvent: AssetErrorEventDataFragment,
): string => {
  if (assetErrorEvent.__typename === "AssetErrorEventVideosAvailable") {
    return assetErrorEvent.isInferred
      ? "A Vision Video has been created"
      : "New Video Available";
  }
  return "New Error Detected";
};

export default function AssetErrorPopup({
  assetErrorEvent,
  handleOnClose,
}: AssetErrorPopupProps) {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    const notificationType =
      assetErrorEvent.__typename === "AssetErrorEventVideosAvailable"
        ? "success"
        : "error";

    const assetError = assetErrorEvent.assetError;
    const key = `${assetError.id}-${assetErrorEvent.eventType}`;

    api.open({
      key,
      message: getErrorMessage(assetErrorEvent),
      description: `Error ID ${formatAssetErrorId(assetError.id)}`,
      type: notificationType,
      duration: 10,
      showProgress: true,
      onClose: handleOnClose,
      btn: (
        <NavigateButton
          targetPath={`asset-signal/${assetError.assetSignal.id}/asset-error`}
          id={assetError.id}
          name="Show"
          size="small"
        />
      ),
    });
  }, [assetErrorEvent, handleOnClose, api]);

  return contextHolder;
}
